<template>
  <div class="color-tip-box">
    <div class="color-box" :style="{backgroundColor:color}"></div>
    <div :style="{color:color}">
      <slot></slot>
    </div>
  </div>
</template>

<script>
/**
 * 颜色提示说明组件
 */
export default {
  name: 'color-tip',
  props: {
    color: {
      type: String,
      default: '#a400a2'
    }
  }
}
</script>

<style lang="scss" scoped>
.color-tip-box {
  display: flex;
  align-items: center;

  .color-box {
    width: 16px;
    height: 16px;
    margin: 0 4px 0 10px;
  }
}
</style>
